import Decimal from 'decimal.js-light';

export const diameterFieldResultAm = (value: string) => new Decimal(value || 0)
    .dividedBy(12)
    .dividedBy(2)
    .pow(2).mul(Math.PI).toFixed(2);
